
<Wrapper background="tooltip" border-radius="4px">
	<Container :padding="8" :gap="8" direction="column">
		<Typography type="p3" color="light" weight="bold">
			{{ formatTitle(title) }}
		</Typography>
		<Container :padding="0" :gap="4" direction="column">
			<Container
				v-for="(p, index) in points"
				:key="p.index + p.name + index"
				align="space-between center"
				:padding="0"
			>
				<Typography type="p3" color="dark">
					{{ p.name }}
				</Typography>
				<Typography type="p3" color="dark" weight="bold">
					{{ p.value }}
				</Typography>
				<!-- <span class="flow-t-tooltip-point-value" :style="'color:' + p.color">{{ p.value }}</span> -->
			</Container>
		</Container>
	</Container>
</Wrapper>
